document.addEventListener('submit', function (e) {
  const form = e.target.closest('form[action*="/cart/add"]');
  if (!form) return;

  const inputs = form.querySelectorAll('.personalisation-input');
  if (!inputs.length) return;

  let valid = true;

  inputs.forEach(input => {
    if (!input.value.trim()) {
      input.classList.add('personalisation-error');
      valid = false;
    } else {
      input.classList.remove('personalisation-error');
    }
  });

  if (!valid) {
    e.preventDefault();
    e.stopImmediatePropagation();
    alert('Please complete all personalisation fields before adding to cart.');
  }
}, true);
